import { titles } from './data.ts';

export default {
  component: () => import('./page.vue'),
  path: '/intro/:sensorType(22|18|resp_rate)',
  name: 'intro',
  meta: {
    title: '指标说明',
    titleMaps: titles,
    titleKey: 'sensorType',
  },
};
